<div class="wgu-container">
  <h2>Reset Password</h2>

  <div class="h1">Step 3: Create a New Password</div>

  <p class="mb-6">Please enter and confirm your new password.</p>

  <p class="mb-6">Password must meet the following strength requirements:</p>
  <div>
    <ul>
    <li>Must be 12 or more characters</li>

    <li>Must contain at least one of the following:</li>
    <li class="mx-8">An uppercase letter</li>
    <li class="mx-8">A lowercase letter</li>
    <li class="mx-8">A numerical digit</li>
    <li>Can include basic symbols</li>
    <li>Do not include your name or username</li>
    <li>Do not use a password that you use elsewhere</li>
    <li>
      Do not include personal information, such as your birthday or Social
      Security number
    </li>
  </ul>
  </div>
  <div>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <!--<div>
      <em>{{errorResponse}}</em>
    </div>-->

      <div class="form-group">
        <label class="wgu-outlined general">
          <input
            [ngClass]="{
              error:
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.touched,
              'error-has-value':
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.value
            }"
            formControlName="password"
            name="password"
            id="password"
            type="password"
            class="form-control"
            placeholder="   "
          />
          <span
            [ngClass]="{
              error:
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.touched
            }"
            >Password
          </span>

          <p
            *ngIf="
              f.password?.errors?.required &&
              resetPasswordForm.controls.password?.touched
            "
            class="error-label"
          >
            Password is required
          </p>
          <p
            *ngIf="
              f.password?.errors?.minlength &&
              resetPasswordForm.controls.password?.touched
            "
            class="error-label"
          >
            Password must be at least 12 characters
          </p>
          <p
            *ngIf="
              f.password?.errors?.general &&
              resetPasswordForm.controls.password?.touched
            "
            class="error-label"
          >
            Password is missing a Capital/Lower letter or a digit
          </p>

          <button
            [ngClass]="{
              hide: !passwordShow,
              imgoffadj:
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.touched
            }"
            (click)="toggle('passwordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password"
              id="psweyeon"
              src="/assets/images/securityquestions/eyeon.png"
              width="25"
            />
          </button>
          <button
            [ngClass]="{
              hide: passwordShow,
              imgoffadj:
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.touched
            }"
            (click)="toggle('passwordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password"
              id="psweyeoff"
              src="/assets/images/securityquestions/eyeoff.png"
              width="25"
            />
          </button>
        </label>
      </div>

      <div class="form-group">
        <label class="wgu-outlined general">
          <input
            [ngClass]="{
              error:
                resetPasswordForm.controls.confirmPassword?.invalid &&
                resetPasswordForm.controls.confirmPassword?.touched,
              'error-has-value':
                resetPasswordForm.controls.confirmPassword?.invalid &&
                resetPasswordForm.controls.confirmPassword?.value
            }"
            formControlName="confirmPassword"
            name="confirmPassword"
            id="confirmPassword"
            type="password"
            class="form-control"
            placeholder="   "
          />
          <span
            [ngClass]="{
              error:
                resetPasswordForm.controls.confirmPassword?.invalid &&
                resetPasswordForm.controls.confirmPassword?.touched,
              'error-has-value':
                resetPasswordForm.controls.password?.invalid &&
                resetPasswordForm.controls.password?.value
            }"
            >Confirm Password</span
          >

          <p
            *ngIf="
              f.confirmPassword?.errors?.mustMatch &&
              resetPasswordForm.controls.confirmPassword?.touched
            "
            class="error-label"
          >
            Passwords must match
          </p>
          <button
            [ngClass]="{
              hide: !confirmPasswordShow,
              imgoffadj:
                resetPasswordForm.controls.confirmPassword?.invalid &&
                resetPasswordForm.controls.confirmPassword?.touched
            }"
            (click)="toggle('confirmPasswordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password (confirm password)"
              id="newpsweyeon"
              src="/assets/images/securityquestions/eyeon.png"
              width="25"
            />
          </button>
          <button
            [ngClass]="{
              hide: confirmPasswordShow,
              imgoffadj:
                resetPasswordForm.controls.confirmPassword?.invalid &&
                resetPasswordForm.controls.confirmPassword?.touched
            }"
            (click)="toggle('confirmPasswordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password (confirm password)"
              id="newpsweyeoff"
              src="/assets/images/securityquestions/eyeoff.png"
              width="25"
            />
          </button>
        </label>
      </div>
      <div *ngIf="errorResponse && displayError" class="error-message my-3">
        <div class="error-message-left">
          <img
            alt="Error Message"
            class="img-responsive"
            src="/assets/images/landing/warning.png"
            width="56"
          />
        </div>

        <div class="error-message-middle">{{ errorResponse }}</div>

        <button (click)="closeDisplayError()" class="error-message-right">
          <img
            alt="Close Error Message"
            class="img-responsive"
            src="/assets/images/securityquestions/Close.png"
            width="16"
          />
        </button>
      </div>
      <div class="form-actions">
        <button class="wgu-btn" type="submit">{{ submitted == true ? 'Submitting...' : 'Next' }}</button>
        <a
          href="identityiq/external/forgotPassword/cancelPage"
          class="wgu-btn-text"
          >Cancel</a
        >
      </div>
    </form>
  </div>
</div>
